import { getCurrentBalance } from "../../js/api/balance.js";
import {
  getUsers,
  blockusers,
  userhierarchyforall,
  searchUsers,
} from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";

let UsersNew = {
  render: async () => {
    let users = await getUsers();
    let myUser = users.data.user;
    let childrenUsers = users.data.children_users;
    let usersView = ``;
    let myUserView = ``;
    let eur = 0;
    let usd = 0;
    let lek = 0;
    let mkd = 0;
    if (myUser.total_coins && myUser.total_coins.includes("|")) {
      const allCurrencies = myUser.total_coins.split("|");

      allCurrencies.forEach((currency) => {
        const id = currency.split(";")[0].split(".")[0];
        const value = currency.split(";")[1];
        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
      });
    } else {
      if (myUser.currency_id) {
        if (myUser.currency_id == 1) eur += parseFloat(myUser.total_coins || 0);
        if (myUser.currency_id == 2) lek += parseFloat(myUser.total_coins || 0);
        if (myUser.currency_id == 3) usd += parseFloat(myUser.total_coins || 0);
      } else if (myUser.total_coins !== null) {
        const value = myUser.total_coins.split(";")[1];

        const id = myUser.total_coins.split(";")[0].split(".")[0];

        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
      }
    }
    myUserView =
      myUserView +
      `<div class="myBalanceTableRow">
                    <span>${myUser.name}</span>
                    <span>${parseFloat(eur).toFixed(2)}</span>
                    <span>${parseFloat(lek).toFixed(2)}</span>
                    <span>${parseFloat(usd).toFixed(2)}</span>
               </div>`;

    const uniqueChildrenUsers = [
      ...new Set(childrenUsers.map((item) => item.username)),
    ].sort();

    uniqueChildrenUsers.forEach((childrenUser) => {
      const users = childrenUsers.filter((a) => a.username == childrenUser);
      console.log(users[0]);
      usersView =
        usersView +
        `<div  class="myBalanceTableRow2 ${users[0].role_name} ${users[0].state == 1 ? "notBlocked" : "blocked"} ${users[0].state == 1 ? "visible" : ""}">
      
      <a class="expandRowList" target-id="${users[0].id}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg></a><a class="userRowLink" href="#/userprofile/${users[0].id}?state=${users[0].state}">`;

      usersView =
        usersView +
        `              <span>${childrenUser}</span>
                  <span>${parseFloat(users.filter((a) => a.currency == "EURO")[0] ? users.filter((a) => a.currency == "EURO")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(users.filter((a) => a.currency == "LEK")[0] ? users.filter((a) => a.currency == "LEK")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(users.filter((a) => a.currency == "USD")[0] ? users.filter((a) => a.currency == "USD")[0].total_coins : 0).toFixed(2)}</span>
                  `;

      usersView =
        usersView +
        `</a> ${users[0].state == "1" ? `<span class="btnListRow"><a class="generalButton-small blockUser" data-child-id="${users[0].id}" data-state="3" id="returnCanceledBtn"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg></a></span>` : `<span class="btnListRow"><a class="generalButtonGreen-small blockUser"  data-child-id="${users[0].id}"  data-state="1" id="returnCanceledBtn"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg></a></span>`}</div>`;
    });

    let view = /*html*/ `
            <div class="usersHeader m-t-6">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                 <span>${_t("Users")}</span>
           </div>
           <div class="tableLabel m-t-50">
               <span>${_t("Balanca ime")}</span>
            </div>
           <div class="userContent">
               <div class="myBalanceTable">
                   <div class="myBalanceTableHeader">
                       <span></span>
                       <span>EURO</span>
                       <span>LEK</span>
                       <span>USD</span>
                    </div>
                   ${myUserView}
               </div>
           </div>
           <div class="filterWrapperMain">
              <a class="filterBtnMain notBlockedPlayer active">${_t("Aktiv")}</a>
              <a class="filterBtnMain blockedPlayer">${_t("Te bllokuar")}</a>
            </div>
           <div class="tableLabel">
               <span>${_t("Balanca e secilit perdorues")} <a class="generalButton-sm blockUser" id="returnCanceledBtn"  data-child-id="0">${_t("Blloko të gjithë")}</a></span>
               
               
            </div>
            <div class="usersContent">
               <div class="myBalanceTable">
                    <div class="searchUserwrapper aktiveSearch active">
                      <input class="searchUser" type="text" />
                      <button type="button" class="users_searchBtn">${_t("Search")}</button>
                    </div>

                    <div class="all-users">
                      <div class="myBalanceTableHeader2">
                        <span></span>
                        <span>EURO</span>
                        <span>LEK</span>
                        <span>USD</span>
                        <span>${_t("Blloko")}</span>
                      </div>
                      ${usersView}
                    </div>          
                    <div class="search-users" hidden>
                      <div class="label" style="color: white; padding: 10px 0; font-size: 14px"></div>
                      <div class="data" hidden>
                        <div class="myBalanceTableHeader2">
                          <span></span>
                          <span>EURO</span>
                          <span>LEK</span>
                          <span>USD</span>
                          <span>${_t("Blloko")}</span>
                        </div>
                        <div class="rows"></div>
                      </div>
                    </div>                     
               </div>
           </div>
       `;
    return view;
  },
  after_render: async () => {
    $("body").on("click", ".expandRowList", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if ($(e.currentTarget).parent().hasClass("expandNow")) {
        $(e.currentTarget).parent().removeClass("expandNow");
        $(e.currentTarget).siblings(".userHierarchyWrapper").remove();
      } else {
        let userId = $(e.currentTarget).attr("target-id");
        let childrenUser = await userhierarchyforall(userId);
        let childrenUserArray = childrenUser.data.children_users;
        console.log(childrenUserArray);
        if (childrenUserArray.length !== 0) {
          let usersView = ``;
          const uniqueChildrenUsers = [
            ...new Set(childrenUserArray.map((item) => item.username)),
          ].sort();
          $.each(uniqueChildrenUsers, function (i, username) {
            const item = childrenUserArray.filter(
              (a) => a.username == username,
            )[0];
            const others = childrenUserArray.filter(
              (a) => a.username == username,
            );
            usersView =
              usersView +
              `
                <div  class="myBalanceTableRow2 ${item.role_name} ${item.state == 1 ? "notBlocked" : "blocked"} ${item.state == 1 ? "visible" : ""}">
                  <a class="expandRowList" target-id="${item.id}">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none">
                          <path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path>
                      </svg>
                  </a><a class="userRowLink" href="#/userprofile/${item.id}?state=${item.state}">`;
            usersView =
              usersView +
              ` <span>${item.username}</span>
                  <span>${parseFloat(others.filter((a) => a.currency == "EURO")[0] ? others.filter((a) => a.currency == "EURO")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(others.filter((a) => a.currency == "LEK")[0] ? others.filter((a) => a.currency == "LEK")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(others.filter((a) => a.currency == "USD")[0] ? others.filter((a) => a.currency == "USD")[0].total_coins : 0).toFixed(2)}</span>
                                            `;
            usersView =
              usersView +
              `</a>
                ${
                  item.state == "1"
                    ? `
                  <span class="btnListRow">
                    <a class="generalButton-small blockUser" data-child-id="${item.id}" data-state="3" id="returnCanceledBtn">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg>
                        </a>
                  </span>`
                    : `<span><a class="generalButtonGreen-small blockUser"  data-child-id="${item.id}"  data-state="1" id="returnCanceledBtn">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg>
                  </a>
                  </span>`
                }</div>`;
          });
          $(e.currentTarget)
            .parent()
            .append(`<div class="userHierarchyWrapper">${usersView}</div>`);
          $(e.currentTarget).parent().addClass("expandNow");
        }
      }
    });

    // $('body').on('keyup', '.aktiveSearch input', function(e){
    //   console.log($(e.currentTarget).val().toLowerCase(), 'asdasdasd');
    //     $(e.currentTarget).parent().parent().addClass('searchPerformed');
    //     $(e.currentTarget).parent().parent().children('.notBlocked').each(function(i, item){
    //         if( $(item).children('a').children('span:first').text().toLowerCase().includes($(e.currentTarget).val().toLowerCase())){
    //           $(item).addClass('searchFound');
    //         }else {
    //           $(item).removeClass('searchFound');
    //         }
    //     });
    // });

    // $('body').on('keyup', '.blockedSearch input', function(e){
    //   console.log($(e.currentTarget).val().toLowerCase());
    //   $(e.currentTarget).parent().parent().addClass('searchPerformed');
    //   $(e.currentTarget).parent().parent().children('.blocked ').each(function(i, item){
    //       if( $(item).children('a').children('span:first').text().toLowerCase().includes($(e.currentTarget).val().toLowerCase())){
    //         $(item).addClass('searchFound');
    //       }else {
    //         $(item).removeClass('searchFound');
    //       }
    //   });
    // });

    $("body .searchUserwrapper button").unbind("click");
    $("body").on("click", ".searchUserwrapper button", async function (e) {
      const user = $(".searchUserwrapper input").val();
      if (!user) return;

      $(".all-users").attr("hidden", true);
      $(".search-users").removeAttr("hidden");
      $(".search-users .label").text("Searching...Please wait!");
      $(".search-users .data").attr("hidden", true).find(".rows").html("");

      const roles = ["User", "Agent", "Manager", "Supermanager", "Admin"];
      let searchResult = await searchUsers(user);

      if (searchResult && searchResult.length > 0) {
        $(".search-users .label").text(`Search result for: ${user}`);
      } else {
        $(".search-users .label").text(
          `We couldn't find any user with username: ${user}`,
        );
        return;
      }

      searchResult = searchResult.map((s) => {
        s["role_index"] = roles.indexOf(s.role_name);
        return s;
      });

      const uniqueSearchResult = [
        ...new Set(
          searchResult
            .sort((a, b) => {
              if (roles.indexOf(a.role_name) > roles.indexOf(b.role_name))
                return -1;
              if (roles.indexOf(a.role_name) < roles.indexOf(b.role_name))
                return 1;
              return 0;
            })
            .map((item) => item.username),
        ),
      ];

      let searchView = ``;
      uniqueSearchResult.forEach((username) => {
        const user = searchResult.find((s) => s.username === username);
        const getCurrency = (username, currency) => {
          const userCurrency = searchResult.find(
            (s) => s.username === username && s.currency === currency,
          );
          if (userCurrency) {
            return parseFloat(userCurrency.total_coins).toFixed(2);
          }
          return "0.00";
        };

        searchView += `
          <div class="myBalanceTableRow2 visible ${user.role_name}">
            <a class="userRowLink" style="width: calc(100% - 40px)" href="#/userprofile/${user.id}?state=${user.state}">
              <span style="line-height: 1; padding-top: 10px;">${user.username}<br /><small style="opacity: 0.7">${user.role_name}</small></span>
              <span>${getCurrency(username, "EURO")}</span>
              <span>${getCurrency(username, "LEK")}</span>
              <span>${getCurrency(username, "USD")}</span>
            </a>
            ${
              user.state == "1"
                ? `<span class="btnListRow"><a class="generalButton-small blockUser" data-child-id="${user.id}" data-state="3" id="returnCanceledBtn"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg></a></span>`
                : `<span class="btnListRow"><a class="generalButtonGreen-small blockUser"  data-child-id="${user.id}"  data-state="1" id="returnCanceledBtn"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><g><path d="M12,18.5c0-2.179,1.085-4.202,2.904-5.413c0.064-0.043,0.118-0.1,0.157-0.167c0.292-0.508,0.439-0.986,0.439-1.419    c0-0.354,0.105-0.5,0.121-0.515c0.156-0.039,0.284-0.15,0.343-0.299C16.019,10.549,16.5,9.323,16.5,8.5    c0-0.041-0.005-0.082-0.015-0.121C16.43,8.16,16.277,7.839,16,7.651V5c0-1.611-0.492-2.272-1.01-2.655C14.891,1.569,14.06,0,11,0    C7.902,0,6,2.912,6,5v2.651C5.723,7.839,5.57,8.16,5.515,8.379C5.505,8.418,5.5,8.459,5.5,8.5c0,0.823,0.481,2.049,0.536,2.186    c0.06,0.149,0.148,0.248,0.304,0.287C6.395,11,6.5,11.146,6.5,11.5c0,0.95,0.713,2.006,1.478,2.708    c-0.105,0.655-0.593,2.382-1.636,2.818l-4.438,1.479c-1.219,0.406-1.628,1.428-1.889,2.471C0.005,21.016,0,21.057,0,21.098V23.5    C0,23.776,0.224,24,0.5,24h13.105c0.203,0,0.386-0.123,0.463-0.311s0.032-0.404-0.113-0.546C12.694,21.908,12,20.26,12,18.5z"/><path d="M18.5,13c-3.033,0-5.5,2.467-5.5,5.5s2.467,5.5,5.5,5.5s5.5-2.467,5.5-5.5S21.533,13,18.5,13z M20.854,20.146    c0.195,0.195,0.195,0.512,0,0.707C20.756,20.951,20.628,21,20.5,21s-0.256-0.049-0.354-0.146L18.5,19.207l-1.646,1.646    C16.756,20.951,16.628,21,16.5,21s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l1.646-1.646l-1.646-1.646    c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l1.646,1.646l1.646-1.646c0.195-0.195,0.512-0.195,0.707,0    s0.195,0.512,0,0.707L19.207,18.5L20.854,20.146z"/></g></g></svg></a></span>`
            }
            </div>`;
      });

      $(".search-users .data")
        .removeAttr("hidden")
        .find(".rows")
        .html(searchView);
    });

    function clearSearch() {
      $(".all-users").removeAttr("hidden");
      $(".search-users").attr("hidden", true);
      $(".search-users .label").text("");
      $(".search-users .data .rows").html("");
    }

    $("body").on("click", ".filterBtnMain", function (e) {
      clearSearch();

      $(e.currentTarget).parent().children("a").removeClass("active");
      $(e.currentTarget).addClass("active");

      $(".aktiveSearch input").val("");
      $(".myBalanceTable").removeClass("searchPerformed");
      $(".myBalanceTableRow2").removeClass("searchFound");

      if ($(e.currentTarget).hasClass("notBlockedPlayer")) {
        // $('body .searchUser').val('');
        // $('body .searchUserwrapper.aktiveSearch ').addClass('active');
        // $('body .searchUserwrapper.blockedSearch').removeClass('active');

        $("body .myBalanceTableRow2").each(function (i, item) {
          if ($(item).hasClass("notBlocked")) {
            $(item).addClass("visible");
          } else {
            $(item).removeClass("visible");
          }
        });
      }
      if ($(e.currentTarget).hasClass("blockedPlayer")) {
        // $('body .searchUser').val('');
        // $('body .searchUserwrapper.blockedSearch ').addClass('active');
        // $('body .searchUserwrapper.aktiveSearch').removeClass('active');

        $("body .myBalanceTableRow2").each(function (i, item) {
          if ($(item).hasClass("blocked")) {
            $(item).addClass("visible");
          } else {
            $(item).removeClass("visible");
          }
        });
      }
    });
    var currentBalanceResult = await getCurrentBalance();
    var coins = [];
    var allText = "";

    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
        allText += `<b>${currentBalanceResult.currency} ${parseFloat(currentBalanceResult.total_coins).toFixed(2)} </b>`;
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });

        const value = currentBalanceResult.total_coins.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    }

    $(".currentBalanceNew").html(allText);

    localStorage.setItem("coins", JSON.stringify(coins));

    $("body").on("click", ".blockUser", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      let childId = $(e.currentTarget).attr("data-child-id");
      let state = $(e.currentTarget).attr("data-state");
      console.log(childId);
      var r = confirm(_t("Jeni te sigurt?"));
      if (r == true) {
        const res = await blockusers(childId, state);
        location.reload();
      }
    });
  },
};

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

export default UsersNew;
